
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      isDialogOpen: false,
      dialogComponent: null,
      dialogStackLength: 0,
      dialogPopValue: null,
      dialogParams: {} as any,
      dialogTitle: '',
      dialogStack: [] as any,
      onCloseDialog: null as any,
    };
  },
  mounted() {
    // download link event listener from child pages
    this.$root.$on('open-dialog', this.openDialog);
    this.$root.$on('push-dialog', this.pushDialog);
    this.$root.$on('pop-dialog', this.popDialog);
    this.$root.$on('close-dialog', this.closeDialog);
    window.addEventListener('keyup', this.handleKeys);
  },
  destroyed() {
    this.$root.$off('open-dialog');
    this.$root.$off('close-dialog');
    window.removeEventListener('keyup', this.handleKeys);
  },
  created() {
    this.dialogStack = [];
  },
  methods: {
    openDialog(dialog: any, dialogProps: any) {
      this.isDialogOpen = true;
      this.dialogStack = [dialog];
      this.displayDialog();
      this.onCloseDialog = dialogProps ? dialogProps.onClose : null;
    },
    displayDialog() {
      const dialog = this.dialogStack[this.dialogStack.length - 1];
      this.dialogTitle = dialog.title;
      this.dialogComponent = dialog.component;
      this.dialogParams = dialog.params;
      this.dialogStackLength = this.dialogStack.length - 1;
    },
    pushDialog(dialog: any) {
      this.dialogStack.push(dialog);
      this.displayDialog();
    },
    popDialog(value: any) {
      this.dialogStack.pop();
      this.dialogPopValue = value;
      this.displayDialog();
    },
    closeDialog(params: any) {
      this.isDialogOpen = false;
      this.dialogComponent = null;
      this.dialogParams = {};
      this.dialogStack = [];
      this.dialogStackLength = 0;
      if (this.onCloseDialog) {
        this.onCloseDialog(params);
      }
      this.onCloseDialog = undefined;
    },
    handleKeys(e: any) {
      // escape
      if (e.keyCode === 27) {
        this.closeDialog({});
      }
    },
  },
});
